import { createSubstrateSearchQueryHeaders } from './helpers/createSubstrateSearchQueryHeaders';
import { makePostRequest } from 'owa-ows-gateway';
import { Mini3SScenario } from '../schema/SubstrateScenarios';
import { SUBSTRATE_SEARCH_QUERY_ENDPOINT } from './serviceConstants';
import { SubstrateSearchRequest } from '../schema/SubstrateSearchRequest';
import { SubstrateSearchResponse } from '../schema/SubstrateSearchResponse';
import { with3SResponseReceivedSignal } from '../utils/with3SResponseReceivedSignal';

/**
 * Service call wrapper to 3S Query V2 API.
 */
export async function execute3SQueryService(
    substrateSearchRequest: SubstrateSearchRequest,
    searchSessionId: string,
    customHeaders?: { [key: string]: string }
): Promise<SubstrateSearchResponse> {
    const { LogicalId: logicalId, Scenario } = substrateSearchRequest;

    const requestHeaders = createSubstrateSearchQueryHeaders(searchSessionId, customHeaders);

    const getSearchResultsService = (clientRequestId: string) =>
        makePostRequest(
            SUBSTRATE_SEARCH_QUERY_ENDPOINT,
            substrateSearchRequest /* requestObject */,
            clientRequestId /* correlationId (client-request-id) */,
            true /* returnFullResponse */,
            requestHeaders /* customHeaders */,
            true /* throwServiceError */,
            undefined /* sendPayloadAsBody */,
            false /* includeCredentials */
        );

    return with3SResponseReceivedSignal<SubstrateSearchResponse>(
        '3SQueryRequest',
        getSearchResultsService,
        logicalId,
        Mini3SScenario[Scenario.Name]
    );
}
